import { useBucket } from '@mc/experiments-react'

import { REVAMPED_PRICING_COPY_EXP_FLAG } from './constants'

export const useRevampedPricingCopyExp = () => ({
  isPen4819Variant: useBucket(REVAMPED_PRICING_COPY_EXP_FLAG) === 'variant_1',
})
